import React, { useEffect, useState } from "react";

import BackButton from "../../Components/BackButton";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";
import { useAddBrandMutation } from "../../Redux/Apis/Brands";
import { useUploadImageMutation } from "../../Redux/Apis/General";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { objectValidator } from "../../Utils";

const AddBrand = () => {

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'The Turn At | Add Brand';
    }, []);

    const [add, { isLoading, isSuccess, data }] = useAddBrandMutation();
    const [upload, { isLoading: uploadingImage }] = useUploadImageMutation();

    const [name, setName] = useState("")
    const [image, setImage] = useState("")

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message)
            navigate('/brands')
        }
    }, [isSuccess]);

    const onClickSave = () => {

        let validate = objectValidator({ name, image })

        if (validate) {

            let form = new FormData()
            form.append('image', image)

            upload(form).then(res => {
                if (res && res.data) {
                    add({
                        name,
                        image: res.data.path
                    })
                }
            }).catch(err => {
                console.log("Error while uploading image", err)
            })

        }
    }

    return (
        <>
            <DashboardLayout>
                <div className="dashCard mb-4">
                    <div className="row mb-3">
                        <div className="col-12">
                            <h2 className="mainTitle">
                                <BackButton />
                                Add New Brand
                            </h2>
                        </div>
                    </div>
                    <div className="d-flex mb-3">
                        {
                            image && <img className="mx-2" src={URL.createObjectURL(image)} style={{ width: '200px', height: '200px', objectFit: 'contain', borderRadius: 12, backgroundColor: '#F0F0F0' }} />
                        }
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <CustomInput
                                label="Brand Image"
                                labelClass="mainLabel"
                                required
                                type="file"
                                placeholder="Enter Brand Name"
                                inputClass="mainInput"
                                value={image?.filename}
                                onChange={(e) => setImage(e.target.files[0])}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <CustomInput
                                label="Brand Name"
                                labelClass="mainLabel"
                                required
                                placeholder="Enter Brand Name"
                                inputClass="mainInput"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <CustomButton
                                text="Save"
                                onClick={onClickSave}
                                loading={uploadingImage || isLoading}
                            />
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    );
};

export default AddBrand;